import { lazyView } from '../platform/index.ts';

export { RepoCheckStrip } from './git/RepoCheck.tsx';
export { SdkWarning, useBranchSdkWarning } from './git/SdkVersionsCard.tsx';
export { type StructureVerdict } from './structure/model.ts';

/** Its pages and views the host (or another module) loads when shown. */
export const pages = {
  Versions: () => import('./Versions.tsx'),
  'code/CodePage': () => import('./code/CodePage.tsx'),
  'git/settings-cards': () => import('./git/settings-cards.ts'),
  'repos/PullRequest': () => import('./repos/PullRequest.tsx'),
  'structure/Structure': () => import('./structure/Structure.tsx'),
  'templates/Templates': () => import('./templates/Templates.tsx'),
};

/** Its views other modules show, loaded when shown. */
export const DriftPanel = lazyView(async () => (await import('./git/DriftPanel.tsx')).DriftPanel);
export const StructureReport = lazyView(
  async () => (await import('./structure/StructureReport.tsx')).StructureReport,
);
export const SaveAsTemplateDialog = lazyView(
  async () => (await import('./templates/SaveAsTemplateDialog.tsx')).SaveAsTemplateDialog,
);
